import React, { useEffect } from "react";

import useFetchObjectByPost from "../../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../../Context/InshData";
import { uri } from "../../../../help/Api";
import LoadingPage from "../../../../services/LoadingPage";
import dataF from "../../../../Server/dataF.json";
import { useLocation } from "react-router-dom";
import { getLS } from "../../../../utils/useLS";
import InvoicesScreen from "./InvoicesScreen";
const defaultAutos = {
  Safes: [],
};
export default function InvoicesContianers() {
  const location = useLocation();
  // let branchi= location.state.idata.branch;
  let Prctype = location.state.setting.PrTy_InPr;
  // let usercrt= location.state.idata.create_user;
  let invtype = location.state.stor.invsType;
  let post = location.state.setting?.post ?? 0;
  let locForm = location.state.setting.iformid;
  let isOrder = location.state.isOrder ?? false;
  let orderProceId = location.state.orderProceId ?? 0;
  let orderId = location.state.orderId ?? 0;
  const tb = {
    other: true,
    wait: true,
    CustomersInv: true,
    SafesInv: true,
    StocksInv: true,
    salesmen: true,
    BankInv: true,
    costcenter: true,
    defaultSalesUser: true,
    defaultCenterUser: true,
    InvItems: true,
    // Items: true,
    // PermissionsElemnts: true,
    PermissionsCuCo: true,
    Branches: true,
    MaxShifts: true,
    PermissionsCuCoPurch: invtype == 3 || invtype == 4 || invtype == 6,
    AccountsIndex: invtype == 3 ? true : false,
    groupSub: true,
    PermissionsInvs: true,
    UsersA: true,
    typesInv: true,
    PermissionsTypeInv: true,
    // IsKham:true,
    StepTwo: true,
    PumpsInv: true,
    MaxOrderNo: true,
    stor: { ...sto, branch: sto.branchi },
    parms: {
      tname: invtype == 7 ? "make" : "invs",
      branch: sto.branchi,
      iempid: sto.empi,
      iuserid: sto.idi,
      scurrenciestype: "N",
      takei: 30,
      iformid: invtype === 1 ? 40002 : invtype === 4 ? 40001 : locForm,
      iformidCuCo: dataF[3].id /* for curr and yashml */,
      sProcTypeInvProc: Prctype,
      post: post,
    },

  };

  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );
  useEffect(() => {
    console.log("iam in invoicescontainers", location)
  }, [])
  if (
    fetchAll ||
    !AutoOptions?.Customers
  )
    return <LoadingPage />;

  return (
    <InvoicesScreen
      {...{
        AutoOptions,
        isPurches: invtype == 3 || invtype == 4 || invtype == 6 ? true : false,
        isStock: invtype == 5 || invtype == 7 || invtype == 8 ? true : false,
        isMake: invtype == 7 ? false : false,
        isDialog: false,
        invtype: invtype,
        Prctype: Prctype,
        isOrder: isOrder,
        orderProceId: orderProceId,
        orderId: orderId,
        post: post,
      }}
    />
  );
}
